import React from 'react';
import './src/styles/global.scss';
import { GrowthBookProviders } from './src/providers/GrowthBook';

export const onClientEntry = () => {
  if (typeof document !== 'undefined') {
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = 'https://cdn.comfama.com/comfama-ui/icons/icons.css?v2';
    document.head.appendChild(link);
  }
};

export const wrapRootElement = ({ element }) => {
  return (
    <GrowthBookProviders>
      {element}
    </GrowthBookProviders>
  );
};
